module.exports = __webpack_public_path__ + "img/linkedin-circle-white-48px.ea7908f.svg";